var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('h1'),_vm._v(" "),_c('h2',[_vm._v("欢迎来到我的个人简历")]),_vm._v(" "),_c('h2',[_vm._v("出生日期:1990年6月")]),_vm._v(" "),_c('h2',[_vm._v("QQ:188781475")]),_vm._v(" "),_c('div',{ref:"typed"},[_c('span',{staticClass:"typing"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3571092c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Index.vue
// module id = null
// module chunks = 